import axios from 'axios';
import toast from 'react-hot-toast';

const API_URL = import.meta.env.VITE_BACKEND_URL;

const PATHS_WHERE_404_IS_EXPECTED = ['/api/v1/chat/exports/latest/info'];

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status;
    const isLoginPage = window.location.pathname === '/login';

    if (status === 401) {
      if (isLoginPage) {
        toast.error(error.response?.data?.detail || 'Invalid credentials');
      } else {
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }

    if (
      status === 404 &&
      PATHS_WHERE_404_IS_EXPECTED.some((path) =>
        error.config?.url?.endsWith(path),
      )
    ) {
      return Promise.reject(error);
    }

    const message =
      error.response?.data?.detail ||
      (() => {
        if (!error.response) return "Can't connect to the server.";
        if (status >= 500)
          return "Something went wrong on our end. We've been notified and are looking into it.";

        switch (status) {
          case 403:
            return "You don't have permission to do that.";
          case 404:
            return "We couldn't find what you're looking for.";
          default:
            return "Something went wrong. We've been notified and are looking into it.";
        }
      })();

    toast.error(message);
    return Promise.reject(error);
  },
);

export default axiosInstance;
